import setSentryError from "./setSentryError";

export default async function fetchWrapper<T>(url: string, options?: any) {
    // Logs for debugging
    console.log(`Fetching (${options.method}) ${url}`);
    let response: Response | null | undefined = null;
    // Do fetch request in try catch
    try {
        response = await fetch(url, options);
    } catch (e: any) {
        // Add error to Sentry
        setSentryError(e.name, {
            e,
            url,
            options,
            response
        });
        return {
            code: 500,
            message: 'Failed to fetch',
            error: e.message
        };
    }

    // Convert to JSON
    if (response == null) {
        return { code: 500 };
    }
    try {
        const json: T = await response.json();
        return json;
    } catch (e: any) {
        // Add error to Sentry
        setSentryError('Error in fetchWrapper', {
            e,
            url, options,
            response
        })
    }

    return {
        code: 500
    };
};
